import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q2Fields({ handleUpdate, errors, q2_3 }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>2. Registration Process</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="2.1 How easy was the registration process for your attendees to complete using the link for golf/sporting clay, welcome party, and gifting?"
					reqd={true}
					data={[
						{
							name: "q2_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q2_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q2_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q2_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q2_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q2_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="2.2 How clear were the registration instructions and requirements?"
					reqd={true}
					data={[
						{
							name: "q2_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q2_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q2_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q2_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q2_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q2_2") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="2.3 Did you encounter any issues or questions from your attendees related to registration?"
					reqd={true}
					data={[
						{
							name: "q2_3",
							val: "Yes",
							label: "Yes",
						},
						{
							name: "q2_3",
							val: "No",
							label: "No",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q2_3") ? true : false}
				/>
			</div>

			{q2_3 === "Yes" && (
				<div className="form-group one indent" style={{ marginTop: "0px" }}>
					<Input
						name="q2_3a"
						label="Please describe:"
						reqd={true}
						value={""}
						autocomplete="off"
						update={handleUpdate}
						errors={errors}
					/>
				</div>
			)}

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q2_4"
					label="2.4 What improvements would you recommend for the registration experience?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
